import React, { useMemo } from 'react';
import useContext from '../../../../hooks/useContext';
import { usePrice } from '../providers/PriceProvider';
import { ProductContext } from '../providers/ProductProvider';

const ProductStructuredData = () => {
  const { brand, description, name, productImages, variantId, url, gtin } =
    useContext(ProductContext);

  const { price } = usePrice();

  const markup = useMemo(() => {
    const data: Record<string, any> = {
      '@id': '#product',
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: name,
      description: description,
      sku: variantId,
      offers: {
        '@type': 'Offer',
        url: url,
        priceCurrency: 'SEK',
        price: price,
        // "priceValidUntil": "2029-11-20",
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
      },
    };

    if (productImages?.length) {
      data.image = productImages[0].url;
    }

    if (brand) {
      data.brand = {
        '@type': 'Brand',
        name: brand.name,
        logo: brand.image,
      };
    }

    if (gtin) {
      data.gtin = gtin;
    }

    return JSON.stringify([data]);
  }, []);

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: markup }} />;
};

export default ProductStructuredData;
